<template>
    <div id="regCompany">
    </div>
</template>








<style scoped lang="css">
@import "./../assets/loginstart/style.css";
</style>

<script>
const $ = window.$;
import router from ".././router";
import apiotp from "../utils/otp/apiotp";

export default {

    updated() { },

    mounted: function () {

        console.log("PARAMS: ", this.$route.params.id);

        var pointerVue = this;

        $("#divMenu").hide();

        setTimeout(() => {

            pointerVue.removeAccount();

        }, 100);


    },
    name: "Login",

    // data:

    data() {
        return {

            showResendOtpRegister: true,

            valueOtpRegister: "",




            dialogRegister: true,

            notifications: false,
            sound: true,
            widgets: false,

            showSpinner: false,
            input: {
                regione_sociale: "",
                email: "",
                sede_legale: "",
                partita_iva: "",
                sdi: "",
                pec: "",
                citta: "",
                cap: ""
            },
        };
    },
    methods: {

        removeAccount: async function () {

            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apiotp.removeAccount(
                that.$route.params.id
            ).then((res) => {

                that.$root.$children[0].showProgress = false;

                console.log("res from removeAccount", res);

                that.$swal({
                    icon: "success",
                    text: "Account rimosso correttamente",
                    showConfirmButton: false,
                    timer: 3000
                });

                setTimeout(() => {

                    router.push({
                        path: "/searchAds"
                    });

                }, 200);

            }).catch(err => {
                that.showSpinner = false;
                // that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );


        },

        getUrlDomainGo: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = "http://localhost:4007/";
            }

            if (location.hostname != "localhost") {

                result = "https://filestransfer.it:4007/";

            }

            return result + nome_metodo;

        },

        btnCancelOtpRegister: function () {

            this.$modal.hide('popupOtpRegister');


        },

        btnConfirmOtpRegister: function () {

            if (this.valueOtpRegister != "") {

                console.log("OTP INP: ", this.valueOtpRegister);
                console.log("ENC OTP INP: ", btoa(this.valueOtpRegister));

                if (window.myVal == btoa(this.valueOtpRegister)) {

                    this.$modal.hide('popupOtpRegister');


                    this.registerAction();


                }
                else {

                    this.$swal({
                        icon: "error",
                        text: "Valore OTP non corretto",
                        showConfirmButton: false,
                        timer: 2000
                    });


                }



            }
            else {

                this.$swal({
                    icon: "error",
                    text: "Specificare un  valore dell'OTP",
                    showConfirmButton: false,
                    timer: 2000
                });

            }



        },

        setUrlDomainGlobal: function () {

            let result = "";

            if (window.siteForTest == "") {

                if (location.hostname == "localhost") {
                    result = location.protocol + "//emtool.local/";
                }

                if (location.hostname != "localhost") {

                    result = location.protocol + "//" + location.hostname + "/";

                }

            }
            else {

                result = window.siteForTest;

            }



            window.urlSiteCareers = result;

        },


        getOtpRegister: async function () {

            var that = this;


            window.myVal = "";


            if (window.sendOtp == 1) {

                window.sendOtp = 0;



                that.showSpinner = true;
                // that.$root.$children[0].showProgress = true;


                var v_company_id = 7;

                if (window.urlSiteCareers == "https://careers.ariall.eu/") {
                    v_company_id = 8;
                }



                var response = await apiotp.generateOTPAndSendMailLoginGo(
                    that.input.email,
                    'jobmule',
                    'register_company',
                    v_company_id
                ).then((res) => {

                    that.showSpinner = false;

                    console.log("res from generateOTPAndSendMailLoginGo", res);

                    window.myVal = res.data.Result;


                    setTimeout(() => {

                        that.showResendOtpRegister = true;

                        that.valueOtpRegister = "";

                        $(".contpopupotpregister").show();

                        this.$modal.show('popupOtpRegister');

                        setTimeout(() => {

                            $("#fldValueOtpRegister").focus();

                        }, 300);


                    }, 200);





                }).catch(err => {
                    that.showSpinner = false;
                    // that.$root.$children[0].showProgress = false;
                    console.log(err);
                    var msg = err.response.data.Error;

                    that.$swal({
                        icon: "error",
                        text: msg,
                        showConfirmButton: false,
                        timer: 8000
                    });
                    console.log("Errori", "Non è stato possibile eliminare i dati");
                    console.log("response", response);

                }

                );



            }









        },





        validateEMail: function (v_email) {

            var result;

            var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

            console.log("MAIL: ", v_email);

            if (v_email != undefined) {

                if (v_email != "") {

                    if (v_email.match(validRegex)) {
                        result = true;
                    }
                    else {
                        result = false;

                    }


                }
                else {

                    result = true;

                }


            }
            else {
                result = true;

            }


            return result;

        },


        goBack: function () {

            console.log("GO BACK");

            // var v_page = window.$cookies.get("page_go_back");

            // console.log("PAGE CALL: ", v_page);

            router.push({ path: '/loginAziendaJobmule' }).catch(() => { });


        },



        isEmpty(obj) {
            return Object.keys(obj).length === 0;
        }
        ,
        getCookie() {
            this.$cookies.set("cookie-consent-performance", "yes");

            //  this.$swal('You are logged in!!!');

            //   console.log(Vue.cookie.get('token'));

            // it gets the cookie called `username`
            /* const username = this.$cookies.get("username");
            console.log(username); */
        },

        getUrlDomain(nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = location.protocol + "//emtool.local/";
            }

            if (location.hostname != "localhost") {

                result = "https://companysupport.eu/";

            }

            return result + nome_metodo;


        },

        registerAction: async function () {


            const url = this.getUrlDomainGo("registerCompanyJobmule");


            this.showSpinner = true;

            this.success = false;
            this.error = null;

            let formData = new FormData();


            if (this.input.regione_sociale != undefined)
                formData.append("regione_sociale", this.input.regione_sociale);

            if (this.input.email != undefined)
                formData.append("email", this.input.email);


            if (this.input.partita_iva != undefined)
                formData.append("partita_iva", this.input.partita_iva);


            formData.append("file_logo", $("#input-file-logo")[0].files[0]);


            try {
                await this.axios
                    .post(url, formData, { "content-type": "multipart/form-data" })
                    .then((result) => {
                        var respo = result.data;
                        this.success = true;
                        // console.log( respo   );

                        setTimeout(() => {
                            this.showSpinner = false;

                            var msgError = "";
                            console.log("re", respo.errors);



                            if (respo.errors && !this.isEmpty(respo.errors)) {
                                console.log("Errori", respo.errors);
                                var err = respo.errors;

                                Object.entries(err).forEach(([key, value]) => {
                                    console.log(`${key} ${value}`);
                                    msgError += `${value}\r\n `;
                                });

                                if (msgError) {
                                    this.$swal({ icon: "error", text: msgError });

                                }


                            }
                            else {


                                this.$swal({
                                    icon: "success",
                                    text: "La registrazione e avvenuta con successo, una mail di conferma Le è stata inviata",
                                    showConfirmButton: true,
                                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                                });


                                setTimeout(() => {

                                    this.$router.push({
                                        path: "/searchAds",
                                    });


                                }, 4000);


                            }


                        }, 1);
                    });
            } catch (err) {


                console.log("ERRORE: ", err);


                this.success = false;
                console.log(err.message);
                this.$swal({ icon: "error", text: "Please check your data" });

                this.showSpinner = false;
                //  console.log(   response);

                //   this.error = err.message;
            }
        },

        registerActionOld: async function () {
            //const auth = { user: this.username, password: this.password };
            // Correct username is 'foo' and password is 'bar'
            //const url = "https://app.emtool.eu/api/emt/register";

            const url = "https://app.emtool.eu/registerUserForCompanyPost";

            //const url = "http://emtool.local/registerUserForCompanyPost";


            this.success = false;
            this.error = null;

            let formData = new FormData();

            formData.append("context", "2recruit");

            if (this.input.username != undefined)
                formData.append("login", this.input.username);

            if (this.input.password != undefined)
                formData.append("password", this.input.password);

            formData.append("companyname", "7");

            if (this.input.name != undefined)
                formData.append("name", this.input.name);

            if (this.input.surname != undefined)
                formData.append("surname", this.input.surname);

            if (this.input.email != undefined)
                formData.append("email", this.input.email);

            if (this.input.phone != undefined)
                formData.append("phone", this.input.phone);

            // if (this.input.namecompany != undefined)
            //   formData.append("namecompany", this.input.namecompany);

            formData.append("app", "2recruit");

            formData.append("is_demo", "S");



            try {
                await this.axios
                    .post(url, formData, { "content-type": "text/json" })
                    .then((result) => {
                        var respo = result.data;
                        this.success = true;
                        // console.log( respo   );

                        setTimeout(() => {
                            this.showSpinner = false;

                            var msgError = "";
                            console.log("re", respo.errors);



                            if (respo.errors && !this.isEmpty(respo.errors)) {
                                console.log("Errori", respo.errors);
                                var err = respo.errors;

                                Object.entries(err).forEach(([key, value]) => {
                                    console.log(`${key} ${value}`);
                                    msgError += `${value}\r\n `;
                                });

                                if (msgError) {
                                    this.$swal({ icon: "error", text: msgError });

                                }


                            }
                            else {
                                this.$swal({
                                    icon: "success",
                                    text: "Please check your email",
                                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                                });

                                this.$router.push({
                                    path: "/",
                                });


                            }
                            //this.$swal("You are logged in!!!");

                            /*     window.$cookies.set("token", respo.token , "9y");
                                window.$cookies.set("system", respo.system,"9y");
                                window.$cookies.set("token_system", respo.token_system,"9y");
                                window.$cookies.set("username", respo.username,"9y");
                                window.$cookies.set("user_id", respo.user_id,"9y");
                                window.$cookies.set("namesurname", respo.namesurname,"9y"); */

                            this.$root.$children[0].curDipTop = respo.namesurname;

                            //router.push({ path: "/" });

                        }, 1);
                    });
            } catch (err) {
                this.success = false;
                console.log(err.message);
                this.$swal({ icon: "error", text: "Please check your data" });

                this.showSpinner = false;
                //  console.log(   response);

                //   this.error = err.message;
            }
        },


        checkCap(v_value) {

            var result = true;

            if (v_value.length != 5) {
                result = false;
            }
            else {
                result = /\d/.test(v_value);
            }

            return result;

        },

        checkPartitaIva(v_value) {

            var result = true;

            if (v_value.length != 11) {
                result = false;
            }
            else {
                result = /\d/.test(v_value);
            }

            return result;

        },

        checkSDI(v_value) {

            var result = true;

            if (v_value.length != 5) {
                result = false;
            }


            return result;

        },




        register() {

            var that = this;

            console.log("ok");

            var errore = "";

            if (that.input.regione_sociale == "") {

                errore = "Ragione sociale richiesta";

            }

            if (errore == "") {

                if (that.input.email == "") {

                    errore = "E-Mail richiesta";

                }

            }


            if (errore == "") {

                if (!that.validateEMail(that.input.email)) {

                    errore = "E-Mail non valida";

                }

            }


            if (errore == "") {

                if (that.input.partita_iva == "") {

                    errore = "N. partita iva richiesta";

                }

            }

            if (errore == "") {

                if (!that.checkPartitaIva(that.input.partita_iva)) {

                    errore = "N. partita iva non valido";

                }

            }

            if (errore == "") {
                if ($("#input-file-logo")[0].files.length == 0) {
                    errore = "Specificare l'immagine del logo";
                }
            }

            if (errore == "") {
                if ($("#input-file-logo")[0].files.length > 0) {
                    var estensione22 = $("#input-file-logo")[0].files[0].name.split('.').pop().toLowerCase();
                    if (estensione22 != "png") {
                        errore = "Formati accettati PNG";
                    }
                }
            }

            if (errore == "") {

                const img = new Image();
                img.src = URL.createObjectURL($("#input-file-logo")[0].files[0]);

                img.onload = () => {


                    console.log("WIDTH: ", img.width);
                    console.log("HEIGHT: ", img.height);

                    if ((img.width > 200) || (img.height > 38)) {
                        errore = "Dimensione massima del logo 200px X 38px";
                    }

                    if (errore == "") {

                        console.log("ok");



                        this.getOtpRegister();


                    }
                    else {

                        that.$swal({
                            icon: "error",
                            text: errore,
                            confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                        });

                    }


                    URL.revokeObjectURL(img.src);
                };

            }


            if (errore == "") {

                console.log("ok");



            }
            else {


                this.$swal({
                    icon: "error",
                    text: errore,
                    showConfirmButton: true,
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://app.emtool.eu/public/_lib/img/btn_confirm3_jobmule.png' />",
                });

            }






        },




    },
};
</script>



<style scoped>
#qr-code-wrapper,
#lang-select,
#otp-select {
    display: none;
}

#login {
    width: auto;
    border: 1px solid #cccccc;
    background-color: #ffffff;
    margin: auto;
    /*   margin-top: 200px; */
    padding: 20px;
}

#nav,
.v-sheet {
    display: none;
}
</style>

<style>
.dropify-wrapper {
    height: 236px !important;
    width: 465px !important;
    margin-bottom: 20px !important;
    margin-left: 1px !important;
}

#fldValueOtpRegister {
    text-align: center !important;
}

#regCompany .fs-container .content {
    text-align: center;
    width: 100%;
    position: relative;
    margin: auto;
    margin-top: 240px;
    margin-top: 10vh;
}

#regCompany .clBtnBack {
    width: 40px;
    margin-top: 22px;
    cursor: pointer;
}
</style>